import React from 'react';
import { Link } from 'react-router-dom';

export default function PoliticaPrivacidade() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-acre-dark to-[#1a4a2e] flex items-start justify-center p-4 py-10">
      <div className="w-full max-w-2xl">
        {/* Logo */}
        <div className="text-center mb-6">
          <Link to="/" className="inline-flex items-center gap-2">
            <span className="text-2xl">🌿</span>
            <span className="font-sora font-bold text-2xl text-white">Acre<span className="text-acre-gold">Job</span></span>
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="font-sora font-bold text-2xl text-acre-dark mb-1">Política de Privacidade</h1>
          <p className="text-xs text-gray-400 mb-6">Última atualização: 28/05/2026</p>

          <div className="prose prose-sm max-w-none text-gray-700 space-y-6">

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">1. Dados coletados</h2>
              <p>
                A AcreJob coleta as seguintes informações dos usuários cadastrados na plataforma:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Dados de identificação: nome completo, e-mail, telefone e WhatsApp.</li>
                <li>Dados profissionais: currículo, experiências, formação acadêmica e áreas de interesse (candidatos).</li>
                <li>Dados empresariais: razão social, CNPJ, setor de atuação e dados de contato comercial (empresas).</li>
                <li>Dados de uso: endereço IP, tipo de dispositivo, páginas acessadas e horários de acesso.</li>
                <li>Dados de pagamento: comprovantes enviados para análise; não armazenamos dados de cartão de crédito.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">2. Uso das informações</h2>
              <p>As informações coletadas são utilizadas para:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Criar e gerenciar sua conta na plataforma.</li>
                <li>Conectar candidatos a oportunidades de emprego compatíveis com seu perfil.</li>
                <li>Permitir que empresas publiquem vagas e visualizem perfis de candidatos.</li>
                <li>Processar pagamentos e liberar o acesso aos recursos da plataforma.</li>
                <li>Enviar notificações relevantes sobre vagas, mensagens e atualizações do sistema.</li>
                <li>Melhorar nossos serviços com base em métricas de uso agregadas e anonimizadas.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">3. Compartilhamento</h2>
              <p className="text-sm">
                A AcreJob <strong>não vende</strong> seus dados pessoais a terceiros. O compartilhamento de informações ocorre apenas nas seguintes situações:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Entre candidatos e empresas, para viabilizar o processo de seleção — somente dados do perfil profissional são compartilhados com empresas.</li>
                <li>Com prestadores de serviços essenciais (ex: servidores de hospedagem, provedores de e-mail transacional), que estão contratualmente obrigados a manter a confidencialidade.</li>
                <li>Quando exigido por lei, ordem judicial ou autoridade competente.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">4. Segurança</h2>
              <p className="text-sm">
                Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Criptografia das senhas com algoritmo bcrypt (fator de custo 12).</li>
                <li>Comunicação via HTTPS com certificado SSL/TLS.</li>
                <li>Controle de acesso baseado em perfis (candidato, empresa, administrador).</li>
                <li>Monitoramento de acessos e logs de auditoria para ações sensíveis.</li>
              </ul>
              <p className="text-sm mt-2">
                Apesar de nossos esforços, nenhum sistema é 100% imune a incidentes. Em caso de violação de dados que represente risco significativo, notificaremos os usuários afetados conforme previsto pela LGPD.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">5. Cookies</h2>
              <p className="text-sm">
                Utilizamos cookies e tecnologias similares para:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li><strong>Cookies essenciais:</strong> manter sua sessão autenticada na plataforma.</li>
                <li><strong>Cookies de preferências:</strong> lembrar configurações de interface (ex: filtros de busca).</li>
                <li><strong>Cookies analíticos:</strong> medir o desempenho das páginas de forma anonimizada.</li>
              </ul>
              <p className="text-sm mt-2">
                Você pode configurar seu navegador para bloquear cookies, mas isso pode impedir o funcionamento adequado de alguns recursos da plataforma.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">6. Direitos do usuário (LGPD)</h2>
              <p className="text-sm">
                Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você tem os seguintes direitos:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li><strong>Acesso:</strong> solicitar uma cópia dos dados que mantemos sobre você.</li>
                <li><strong>Correção:</strong> atualizar dados incompletos, inexatos ou desatualizados.</li>
                <li><strong>Exclusão:</strong> solicitar a exclusão dos seus dados pessoais, quando aplicável.</li>
                <li><strong>Portabilidade:</strong> receber seus dados em formato estruturado e legível por máquina.</li>
                <li><strong>Revogação do consentimento:</strong> retirar o consentimento a qualquer momento, sem prejuízo da legalidade dos tratamentos anteriores.</li>
                <li><strong>Oposição:</strong> opor-se ao tratamento realizado com fundamento em legítimo interesse.</li>
              </ul>
              <p className="text-sm mt-2">
                Para exercer seus direitos, entre em contato pelo e-mail indicado na seção 7.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">8. Pagamentos e Segurança Financeira</h2>
              <p className="text-sm">
                A AcreJob utiliza o <strong>Pagar.me</strong> como gateway de pagamento — plataforma certificada com o padrão <strong>PCI DSS</strong> (Payment Card Industry Data Security Standard), garantindo a segurança no processamento de transações financeiras.
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li><strong>Cartão de crédito:</strong> os dados do cartão são enviados diretamente ao Pagar.me via conexão criptografada. Não armazenamos em nossos servidores nenhum dado sensível de cartão (número, CVV, data de validade).</li>
                <li><strong>PIX:</strong> os pagamentos via PIX são processados pelo Pagar.me com criptografia end-to-end. O QR Code gerado é único por transação e expira em 24 horas.</li>
                <li><strong>Reembolsos:</strong> solicitações de reembolso devem ser encaminhadas para <a href="mailto:financeiro@acrejob.com.br" className="text-acre-green hover:underline font-medium">financeiro@acrejob.com.br</a> e serão analisadas conforme a política de reembolso vigente, disponível no painel da empresa.</li>
                <li><strong>Histórico:</strong> mantemos registros das transações realizadas pelo prazo mínimo exigido pela legislação fiscal e financeira brasileira.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">7. Contato</h2>
              <p className="text-sm">
                Para dúvidas, solicitações ou reclamações relacionadas à privacidade e ao tratamento de dados pessoais, entre em contato com nosso Encarregado de Dados (DPO):
              </p>
              <div className="mt-2 bg-acre-light/30 border border-acre-green/20 rounded-xl p-4 text-sm">
                <p><strong>AcreJob Plataforma Digital</strong></p>
                <p>E-mail: <a href="mailto:privacidade@acrejob.com.br" className="text-acre-green hover:underline font-medium">privacidade@acrejob.com.br</a></p>
                <p>Rio Branco — Acre, Brasil</p>
              </div>
            </section>

          </div>
        </div>

        <p className="text-center text-white/40 text-xs mt-5">
          <Link to="/" className="hover:text-white/70">← Voltar ao início</Link>
        </p>
      </div>
    </div>
  );
}
